import React, { useState, useEffect, forwardRef } from 'react';
import {
  Stepper,
  Step,
  StepLabel,
  CircularProgress,
  Grid,
  Paper,
  Typography,
  Divider,
  FormControlLabel,
  FormControl,
  RadioGroup,
  FormHelperText,
  Radio,
  Button,
  Stack,
  TextField,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
} from '@mui/material';
import MaterialTable from '@material-table/core';
import { Chip } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import axios from 'axios';
import { useForm, useFieldArray, Controller, useWatch } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';
import { setFileData } from 'actions/counter';
import useStyles from './styles';
import {
  Link,
  Redirect,
  useNavigate,
  useLocation,
  useRouteMatch,
  Outlet,
} from 'react-router-dom';
// import RankingPosition from '../FormFields/SelectRankingPosition';
import UserService from 'services/user.service';
import eventBus from 'common/EventBus';

const tableIcons = {
  Add: forwardRef((props, ref) => <AssignmentIndIcon {...props} ref={ref} />),
  // Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  // Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  // Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  // DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  // Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  // Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  // Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  // FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  // LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  // NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  // PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  // ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  // Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  // SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  // ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  // ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

const schema = yup.object().shape({
  firstName: yup
    .string()
    .matches(/^([^0-9]*)$/, 'First name should not contain numbers')
    .required('First name is a required field'),
});

function _sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

async function _submitFormRhf(data) {
  await _sleep(1000);
  alert(JSON.stringify(data, null, 2));
  // actions.setSubmitting(false);

  // insert TO DB
  // const isSuccess = await addEmployee(data);
  // if (!isSuccess) {
  //   alert(errMsg);
  // } else {
  //   setActiveStep(activeStep + 1);
  // }
}

const onSubmit = (data) => {
  // if (isLastStep) {
  //   setIsSubmittingFinal(true);
  _submitFormRhf(data);
  // } else {
  console.log('--------EmploymentPage---onSubmit-------');
  // setActiveStep(activeStep + 1);
  // actions.setTouched({});
  // actions.setSubmitting(false);
  // }
  // console.log('data', data);
};

export default function HrInspection() {
  const classes = useStyles();
  // const [errMsg, setErrMsg] = useState('');
  const { user: currentUser } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  // const data = [
  //   { name: 'Mohammad', surname: 'Faisal', birthYear: 1995 },
  //   { name: 'Nayeem Raihan ', surname: 'Shuvo', birthYear: 1994 },
  // ];

  const sample = [
    'สำเนาคุณวุฒิ (Transcript)',
    'ใบปริญญาบัตร',
    'สำเนาทะเบียนบ้านตนเอง',
  ];

  const columns = [
    // { title: 'Name', field: 'name' },
    // { title: 'Surname', field: 'surname' },
    // { title: 'Birth Year', field: 'birthYear', type: 'numeric' },
    //width: 30
    //width: "80%"
    // { title: 'สถานะ', field: '' },
    {
      title: 'เลขที่ใบสมัคร',
      field: 'applicantNo',
    },
    { title: 'เลขบัตรประชาชน', field: 'idCard' },
    {
      title: 'ชื่อ',
      field: 'firstName',
    },
    { title: 'สกุล', field: 'lastName' },
    { title: 'สังกัด', field: 'hDiv' },
    { title: 'รอบ', field: 'hAnnRound' },
    { title: 'ระดับคุณวุฒิ', field: 'hEdu' },
    { title: 'ตำแหน่งที่สมัคร', field: 'hPos' },
    { title: 'รหัสตำแหน่ง', field: 'hJobCode' },
    { title: 'ประเภทอัตรา', field: 'hType' },
    // { title: 'PW', field: 'title' },

    // Grok :
    // material-react-table v1 add chip column example
    // using material-table-core.github.io v1

    //you want to add a chip column using material-table (from material-table-core.github.io),
    //example of how to add a chip column to a material-table implementation using the library hosted at material-table-core.github.io.
    //This library uses a columns array with a render function to customize cell rendering,
    //and we’ll use Material-UI’s Chip component for the chip display

    // Grok :
    // - i want to add a chip column using material-table (from material-table-core.github.io),
    // - example of how to add a chip column to a material-table implementation using the library hosted at material-table-core.github.io.
    // - uses a columns array with a render function to customize cell rendering, and use Material-UI’s Chip component for the chip display

    // when mouse hover on chip it's show list of data

    // {sample.map((detail, index) => (
    //   <li key={index}>{detail}</li>
    // ))}

    // <ul style={{ margin: 0, paddingLeft: 15 }}>{rowData.pw}</ul>

    //     {JSON.stringify(
    //   rowData.pw?.filter((element) => element !== null)
    // )}

    //     {rowData.pw?.fileTypeName?.map((detail, index) => (
    //   <li key={index}>{detail}</li>
    // ))}
    {
      title: 'PW',
      field: 'title',

      render: (rowData) => (
        <Tooltip
          title={
            <div>
              <Typography variant="subtitle2">Details:</Typography>
              <ul style={{ margin: 0, paddingLeft: 15 }}>
                {rowData.pw?.map((detail, index) => (
                  <li key={index}>{detail.fileTypeName}</li>
                ))}
              </ul>
            </div>
          }
          arrow
          placement="top"
          componentsProps={{
            tooltip: {
              sx: {
                bgcolor: 'rgb(79, 148, 194, 0.98)', // Custom background color
                maxWidth: 200, // Limit tooltip width
                fontSize: '0.9rem', // Text size
              },
            },
          }}
        >
          {/* {rowData.pw?.length !== 0 && rowData.pw?.length !== undefined
            ? rowData.pw?.length
            : ''} */}
          {rowData.pw?.length !== 0 && rowData.pw?.length !== undefined ? (
            <Chip
              label={rowData.pw?.length || '0'}
              color={rowData.pw?.length >= 0 ? 'success' : 'default'}
              variant="outlined"
              size="small"
              style={{ cursor: 'pointer' }}
            />
          ) : (
            ''
          )}
        </Tooltip>
      ),

      // render: (rowData) => (
      //   <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
      //     {/* {rowData.hobbies.map((hobby, index) => ( */}
      //     <Chip
      //       key={rowData.idCard}
      //       label={rowData.title}
      //       color="primary"
      //       variant="outlined"
      //     />
      //     {/* ))} */}
      //   </div>
      // ),
    },
  ];

  const {
    control,
    handleSubmit,
    reset,
    getValues,
    setValue,
    formState: { isSubmitting, errors },
  } = useForm({
    defaultValues: {
      title: '---title---',
      positionType: '',
      firstName: '---firstName11---',
      lastName: '---lastName1---',
      // duputy: 'รวห.',
      // rankingPositions: [{ code: 'AF', label: 'Afghanistan', phone: '93' }],
      placeOfBirth: '---',
    },
    resolver: yupResolver(schema),
  });

  const rhf = {
    useForm,
    useWatch,
    useFieldArray,
    Controller,
    control,
    setValue,
    getValues,
    errors,
  };

  // console.log('---isSubmitting----' + isSubmitting);

  // useEffect(() => {
  //   // fetch('http://localhost:3006/api/cis/employees')
  //   fetch('/api/cis/employees')
  //     .then((resp) => resp.json())
  //     .then((resp) => {
  //       setData(resp);
  //     });
  // }, []);

  useEffect(() => {
    const fetchEmps = async () => {
      try {
        setLoading(true);
        // const emps = await UserService.getEmployments();
        const result = await UserService.getEmploymentsWithPw();
        // console.log('--- HrInspection.jsx ---' + JSON.stringify(result));
        setData(result.data.list);
      } catch (error) {
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        console.log('err 001 : ' + _content);

        if (error.response && error.response.status === 403) {
          //401, ให้ logout เมื่อเจอ 403
          eventBus.dispatch('logout');
        }
      } finally {
        setLoading(false);
      }
    };
    fetchEmps();

    // UserService.getEmployments.then(
    //   (response) => {
    //     // setContent(response.data);
    //     setData(response.data);
    //   },
    //   (error) => {
    //     const _content =
    //       (error.response &&
    //         error.response.data &&
    //         error.response.data.message) ||
    //       error.message ||
    //       error.toString();

    //     console.log('err 001 : ' + _content);
    //     // setContent(_content);

    //     if (error.response && error.response.status === 403) {
    //       //401, ให้ logout เมื่อเจอ 403
    //       eventBus.dispatch('logout');
    //     }
    //   }
    // );
  }, []);

  return (
    <React.Fragment>
      <Grid container spacing={2} sx={{ width: '100%' }}>
        {loading ? (
          <Grid item xs={12} style={{ textAlign: 'center' }}>
            <CircularProgress />
            {/* <Typography>Loading data...</Typography> */}
          </Grid>
        ) : (
          <Grid item xs={12}>
            <MaterialTable
              title="ตรวจสอบข้อมูลผู้สมัคร"
              columns={columns}
              data={data}
              icons={tableIcons}
              actions={[
                {
                  icon: 'edit',
                  tooltip: 'ตรวจสอบข้อมูล',
                  onClick: (event, rowData) =>
                    // alert('Applicant No.' + rowData.applicantNo),
                    // <Link to={`/product/edit/${rowData.applicantNo}`}>Edit</Link>
                    navigate(
                      `/app/employment/hr-inspection-emp/${rowData.idCard}`
                    ),
                },
              ]}
              // options={{
              //   actionsColumnIndex: -1,
              // }}
              localization={{
                header: { actions: '' },
                // body: {
                //   addTooltip: 'aaaaa',
                // },
              }}
              options={{
                paging: true,
                pageSize: 5, // make initial page size
                //emptyRowsWhenPaging: false,   // To avoid of having empty rows
                pageSizeOptions: [5, 10, 20, 50], // rows selection options
              }}
            />
          </Grid>
        )}
      </Grid>
    </React.Fragment>
  );
}
